import {
  AssignmentLtiUserMaterial,
  LtiExerciseMaterial,
  ScorableAssignmentLtiUserMaterial,
  ScorableFreeExerciseLtiUserMaterial,
} from './types';

export function isAssignmentLTI(
  material: LtiExerciseMaterial,
): material is AssignmentLtiUserMaterial | ScorableAssignmentLtiUserMaterial {
  return Boolean('assignment' in material && material.assignment && material.assignment.id);
}

export function isScorableLti(
  material: LtiExerciseMaterial,
): material is ScorableAssignmentLtiUserMaterial | ScorableFreeExerciseLtiUserMaterial {
  return Boolean('userMaxScore' in material && material.userMaxScore);
}
